import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ResetPasswordComponent} from './reset-password.component';
import {
    LowerCaseValidatorModule,
    TranslateModule,
    MinCharsValidatorModule,
    NumberValidatorModule,
    RequiredValidatorModule,
    SpecialCharValidatorModule,
    UpperCaseValidatorModule,
    AlertListModule
} from '@xref/ngx';
import {PipeModule} from '../../pipes/pipe.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { OmniLoaderModule } from '../../components/omni-loader/omni-loader.module';
import { ButtonModule} from '@xref/xref-lib';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RequiredValidatorModule,
        RouterModule,
        UpperCaseValidatorModule,
        LowerCaseValidatorModule,
        MinCharsValidatorModule,
        NumberValidatorModule,
        SpecialCharValidatorModule,
        TranslateModule,
        PipeModule,
        OmniLoaderModule,
        TooltipModule,
        AlertListModule,
        ButtonModule
    ],
    declarations: [
        ResetPasswordComponent
    ]
})
export class ResetPasswordModule {}
